import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';

import { getSelectedProfessional } from 'selectors/professionals';
import { getTotalServicesPrice } from 'selectors/services';

import Button from 'components/Button';
import Modal from 'components/Modal/Modal';

import { trackButtonClick } from '../helpers';

import s from './JoinButton.module.css';

const JoinWaitlistButton = () => {
  const router = useRouter();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const totalPrice = useSelector(getTotalServicesPrice);
  const selectedProfessional = useSelector(getSelectedProfessional);

  const closeModal = () => setIsModalOpen(false);
  const goToServicesPage = () => void router.push('/services');
  const handleClick = () => {
    if (selectedProfessional) {
      void router.push('/waitlist');
    } else {
      setIsModalOpen(true);
    }
    trackButtonClick(totalPrice);
  };

  return (
    <>
      <p className={s.separatorText}>OR</p>
      <Button outline type="button" onClick={handleClick}>
        Join Waitlist
      </Button>
      {isModalOpen && (
        <Modal
          className={s.modal}
          onClose={closeModal}
          title="Select Professional"
        >
          <p>Please select a professional in order to join a waitlist</p>
          <div className={s.buttons}>
            <button type="button" onClick={goToServicesPage}>
              OK
            </button>
            <button type="button" onClick={closeModal}>
              Cancel
            </button>
          </div>
        </Modal>
      )}
    </>
  );
};

export default JoinWaitlistButton;
